import { combineReducers } from 'redux'
import * as config from './config'
import translations from './translations'
import routes from './routes'

import { reducer as navigation } from './modules/navigation'
import { reducer as localization } from './modules/localization'

const reducer = combineReducers({
  navigation: navigation(routes),
  localization: localization(
    {
      ...config.localization,
      translations: translations[config.localization.current]
    },
    translations
  )
})

export default reducer
